module.exports = __webpack_public_path__ + "img/empty.b697406a.png";